import { render, staticRenderFns } from "./LedgerEntriesTableBody.vue?vue&type=template&id=0830e5f4&scoped=true&"
import script from "./LedgerEntriesTableBody.vue?vue&type=script&lang=js&"
export * from "./LedgerEntriesTableBody.vue?vue&type=script&lang=js&"
import style0 from "./LedgerEntriesTableBody.vue?vue&type=style&index=0&id=0830e5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830e5f4",
  null
  
)

export default component.exports